/**
 * Remark plugin: replaces mdast image nodes with plain text so the pipeline never
 * emits <img> (avoids arbitrary URL loads, tracking pixels, and mixed-content issues in chat).
 */

function replaceImageNodes(node) {
  if (!node || typeof node !== 'object' || !Array.isArray(node.children)) {
    return;
  }
  node.children = node.children.flatMap(child => {
    if (child.type === 'image') {
      const text =
        (child.alt && String(child.alt).trim()) || String(child.url != null ? child.url : '');
      return [{ type: 'text', value: text }];
    }
    if (child.type === 'imageReference') {
      const text =
        (child.alt && String(child.alt).trim()) ||
        String(child.identifier != null ? child.identifier : child.label || '');
      return [{ type: 'text', value: text }];
    }
    replaceImageNodes(child);
    return [child];
  });
}

export default function remarkStripChatImages() {
  return tree => replaceImageNodes(tree);
}
